import React from 'react';
import type { DataTableLegendItem } from '../types';
import { resolveRowBgColor } from '../rowBgColor';

interface DataTableLegendProps {
  items: DataTableLegendItem[];
}

export default function DataTableLegend({ items }: DataTableLegendProps) {
  return (
    <div className="flex items-center gap-4">
      {items.map((item, index) => {
        const color = resolveRowBgColor(item.color) || '#FFFFFF';
        return (
          <div key={index} className="flex items-center gap-1.5">
            <div
              className="w-4 h-4 rounded border border-gray-300 flex-shrink-0"
              style={{ backgroundColor: color }}
            />
            <span className="text-sm text-gray-600">{item.label}</span>
          </div>
        );
      })}
    </div>
  );
}
